import { getBasePath } from "@/config/basePath";

// Get auth paths with proper basePath
const basePath = getBasePath();

/** *  ==============================
 *  ==============================
 *  ============================== NEXT.JS INTERNAL API ENDPOINTS START ==============================
 *  ==============================
 *  ==============================
 */

/**
 * Next.js Internal API Routes (Server-side)
 */
export const NEXT_API_ROUTES = {
  // API routes
  SET_COOKIES: `${basePath}/api/auth/set-cookies`,
  CLEAR_COOKIES: `${basePath}/api/auth/clear-cookies`,

  // Authentication
  LOGIN: `${basePath}/api/auth/login`,
  LOGOUT: `${basePath}/api/auth/logout`,
  CSRF: `${basePath}/api/auth/csrf`,

  // profile
  GET_USER_PROFILE: `${basePath}/api/auth/user-profile`,
  UPDATE_USER_PROFILE: `${basePath}/api/auth/user-profile`,

  //staff-management
  CREATE_STAFF_MEMBER: `${basePath}/api/staff-management/staff-members/`,
  EDIT_STAFF_MEMBER: `${basePath}/api/staff-management/staff-members/`,
  DELETE_STAFF_MEMBER: `${basePath}/api/staff-management/staff-members/`,

  GET_STAFF_SALARY: `${basePath}/api/staff-management/staff-salary/`,
  CREATE_STAFF_SALARY: `${basePath}/api/staff-management/staff-salary/`,
  UPDATE_STAFF_SALARY: `${basePath}/api/staff-management/staff-salary/`,
  DELETE_STAFF_SALARY: `${basePath}/api/staff-management/staff-salary/`,

  GET_STAFF_BONUS: `${basePath}/api/staff-management/staff-bonus/`,
  CREATE_STAFF_BONUS: `${basePath}/api/staff-management/staff-bonus/`,
  UPDATE_STAFF_BONUS: `${basePath}/api/staff-management/staff-bonus/`,
  DELETE_STAFF_BONUS: `${basePath}/api/staff-management/staff-bonus/`,

  // Tenants
  GET_TENANTS: `${basePath}/api/tenants/`,
  CREATE_TENANT: `${basePath}/api/tenants/`,
  UPDATE_TENANT: `${basePath}/api/tenants/`,
  DELETE_TENANT: `${basePath}/api/tenants/`,
  ACTIVATE_TENANT: `${basePath}/api/tenants/activate/`,
  SUSPEND_TENANT: `${basePath}/api/tenants/suspend/`,

  // Business Applications
  BUSINESS_APPLICATIONS: `${basePath}/api/business-applications`,
  BUSINESS_APPLICATIONS_STATS: `${basePath}/api/business-applications/stats`,
  BUSINESS_APPLICATIONS_APPROVE: `${basePath}/api/business-applications/approve`,
  BUSINESS_APPLICATIONS_REJECT: `${basePath}/api/business-applications/reject`,
  BUSINESS_APPLICATIONS_REQUEST_INFO: `${basePath}/api/business-applications/request-info`,
  BUSINESS_APPLICATIONS_PROVISION: `${basePath}/api/business-applications/provision`,
  BUSINESS_APPLICATIONS_SUBMIT: `${basePath}/api/business-applications/submit`,

  // Business Onboarding
  BUSINESS_ONBOARDING: `${basePath}/api/business-onboarding`,
  BUSINESS_ONBOARDING_DOCUMENTS: `${basePath}/api/business-onboarding/documents`,

  // Business List
  BUSINESS_LIST: `${basePath}/api/business-list`,
  BUSINESS_LIST_SUSPEND: `${basePath}/api/business-list/suspend`,
  BUSINESS_LIST_ACTIVATE: `${basePath}/api/business-list/activate`,
  BUSINESS_LIST_DEACTIVATE: `${basePath}/api/business-list/deactivate`,
  BUSINESS_LIST_REACTIVATE: `${basePath}/api/business-list/reactivate`,
  BUSINESS_LIST_DELETE_DOMAIN: `${basePath}/api/business-list/delete-domain`,
  BUSINESS_LIST_ADD_DOMAIN: `${basePath}/api/business-list/add-domain`,

  // product categories
  GET_CENTRAL_PRODUCTS: `${basePath}/api/products/central-products/`,
  CREATE_CENTRAL_PRODUCT: `${basePath}/api/products/central-products/`,
  UPDATE_CENTRAL_PRODUCT: `${basePath}/api/products/central-products/`,
  DELETE_CENTRAL_PRODUCT: `${basePath}/api/products/central-products/`,

  GET_PRODUCT_CATEGORIES: `${basePath}/api/products/product-categories/`,
  CREATE_PRODUCT_CATEGORY: `${basePath}/api/products/product-categories/`,
  UPDATE_PRODUCT_CATEGORY: `${basePath}/api/products/product-categories/`,
  DELETE_PRODUCT_CATEGORY: `${basePath}/api/products/product-categories/`,

  // hub products
  CREATE_HUB_PRODUCT: `${basePath}/api/products/hub-products/`,
  UPDATE_HUB_PRODUCT: `${basePath}/api/products/hub-products/`,
  DELETE_HUB_PRODUCT: `${basePath}/api/products/hub-products/`,

  // hub categories
  CREATE_HUB_CATEGORY: `${basePath}/api/products/hub-categories/`,
  UPDATE_HUB_CATEGORY: `${basePath}/api/products/hub-categories/`,
  DELETE_HUB_CATEGORY: `${basePath}/api/products/hub-categories/`,

  GET_PRODUCT_REQUESTS: `${basePath}/api/products/request-products/`,
  CREATE_PRODUCT_REQUEST: `${basePath}/api/products/request-products/`,
  UPDATE_PRODUCT_REQUEST: `${basePath}/api/products/request-products/`,
  DELETE_PRODUCT_REQUEST: `${basePath}/api/products/request-products/`,
  APPROVE_PRODUCT_REQUEST: `${basePath}/api/products/request-products/`,
  REJECT_PRODUCT_REQUEST: `${basePath}/api/products/request-products/`,

  // request products
  APPROVE_REQUEST_PRODUCT: `${basePath}/api/products/request-products/approve/`,
  REJECT_REQUEST_PRODUCT: `${basePath}/api/products/request-products/reject/`,

  // tenant assignments
  CREATE_ASSIGNMENT: `${basePath}/api/tenant-assignments/create`,
  DELETE_ASSIGNMENT: `${basePath}/api/tenant-assignments/delete`,

  // email credentials (POST/PATCH/DELETE only - GET uses outsideEndpoints)
  // Note: These are static paths. Client sends ID in request body.
  // Next.js API routes extract ID and construct Django URLs using outsideEndpoints functions.
  CREATE_EMAIL_CREDENTIAL: `${basePath}/api/settings/email-credentials`,
  UPDATE_EMAIL_CREDENTIAL: `${basePath}/api/settings/email-credentials`,
  DELETE_EMAIL_CREDENTIAL: `${basePath}/api/settings/email-credentials/delete`,
  TEST_EMAIL_CREDENTIAL: `${basePath}/api/settings/email-credentials/test`,
  ACTIVATE_EMAIL_CREDENTIAL: `${basePath}/api/settings/email-credentials/activate`,

  // AI Model settings (PUT only - GET uses outsideEndpoints)
  UPDATE_AI_MODEL: `${basePath}/api/settings/ai-model`,

  // Live DNS / HTTPS / SSL status check for the DNS setup panel
  DOMAIN_STATUS: `${basePath}/api/business-list/domain-status`,
} as const;

// =================== INTERNAL API ENDPOINTS ===================
// Legacy exports for backwards compatibility
export const SET_COOKIES_ENDPOINT_NEXT_SERVER = NEXT_API_ROUTES.SET_COOKIES;
export const CLEAR_COOKIES_ENDPOINT_NEXT_SERVER = NEXT_API_ROUTES.CLEAR_COOKIES;

//auth-related
export const LOGIN_ENDPOINT_INSIDE = NEXT_API_ROUTES.LOGIN;
export const LOGOUT_ENDPOINT_INSIDE = NEXT_API_ROUTES.LOGOUT;
export const CSRF_ENDPOINT_INSIDE = NEXT_API_ROUTES.CSRF;

// profile-related
export const GET_USER_PROFILE_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.GET_USER_PROFILE;
export const UPDATE_USER_PROFILE_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.UPDATE_USER_PROFILE;

//staff-management-related
export const CREATE_STAFF_MEMBER_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.CREATE_STAFF_MEMBER;
export const UPDATE_STAFF_MEMBER_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.EDIT_STAFF_MEMBER;
export const DELETE_STAFF_MEMBER_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.DELETE_STAFF_MEMBER;

// staff-salary-related
export const STAFF_SALARY_ENDPOINT_INSIDE = NEXT_API_ROUTES.GET_STAFF_SALARY;
export const CREATE_STAFF_SALARY_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.CREATE_STAFF_SALARY;
export const UPDATE_STAFF_SALARY_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.UPDATE_STAFF_SALARY;
export const DELETE_STAFF_SALARY_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.DELETE_STAFF_SALARY;

// staff-bonus-related
export const STAFF_BONUS_ENDPOINT_INSIDE = NEXT_API_ROUTES.GET_STAFF_BONUS;
export const CREATE_STAFF_BONUS_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.CREATE_STAFF_BONUS;
export const UPDATE_STAFF_BONUS_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.UPDATE_STAFF_BONUS;
export const DELETE_STAFF_BONUS_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.DELETE_STAFF_BONUS;

// cashless-related
export const TENANTS_ENDPOINT_INSIDE = NEXT_API_ROUTES.GET_TENANTS;
export const CREATE_TENANT_ENDPOINT_INSIDE = NEXT_API_ROUTES.CREATE_TENANT;
export const UPDATE_TENANT_ENDPOINT_INSIDE = NEXT_API_ROUTES.UPDATE_TENANT;
export const DELETE_TENANT_ENDPOINT_INSIDE = NEXT_API_ROUTES.DELETE_TENANT;
export const ACTIVATE_TENANT_ENDPOINT_INSIDE = NEXT_API_ROUTES.ACTIVATE_TENANT;
export const SUSPEND_TENANT_ENDPOINT_INSIDE = NEXT_API_ROUTES.SUSPEND_TENANT;

// business-applications-related
export const BUSINESS_APPLICATIONS_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_APPLICATIONS;
export const BUSINESS_APPLICATIONS_STATS_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_APPLICATIONS_STATS;
export const BUSINESS_APPLICATIONS_APPROVE_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_APPLICATIONS_APPROVE;
export const BUSINESS_APPLICATIONS_REJECT_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_APPLICATIONS_REJECT;
export const BUSINESS_APPLICATIONS_REQUEST_INFO_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_APPLICATIONS_REQUEST_INFO;
export const BUSINESS_APPLICATIONS_PROVISION_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_APPLICATIONS_PROVISION;
export const BUSINESS_APPLICATIONS_SUBMIT_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_APPLICATIONS_SUBMIT;

// business-onboarding-related
export const BUSINESS_ONBOARDING_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_ONBOARDING;
export const BUSINESS_ONBOARDING_DOCUMENTS_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_ONBOARDING_DOCUMENTS;

// business-list-related
export const BUSINESS_LIST_ENDPOINT_INSIDE = NEXT_API_ROUTES.BUSINESS_LIST;
export const BUSINESS_LIST_SUSPEND_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_LIST_SUSPEND;
export const BUSINESS_LIST_ACTIVATE_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_LIST_ACTIVATE;
export const BUSINESS_LIST_DEACTIVATE_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_LIST_DEACTIVATE;
export const BUSINESS_LIST_REACTIVATE_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_LIST_REACTIVATE;
export const BUSINESS_LIST_DELETE_DOMAIN_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_LIST_DELETE_DOMAIN;
export const BUSINESS_LIST_ADD_DOMAIN_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.BUSINESS_LIST_ADD_DOMAIN;

// product-categories-related
export const CENTRAL_PRODUCTS_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.GET_CENTRAL_PRODUCTS;
export const CREATE_CENTRAL_PRODUCT_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.CREATE_CENTRAL_PRODUCT;
export const UPDATE_CENTRAL_PRODUCT_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.UPDATE_CENTRAL_PRODUCT;
export const DELETE_CENTRAL_PRODUCT_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.DELETE_CENTRAL_PRODUCT;

export const PRODUCT_CATEGORIES_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.GET_PRODUCT_CATEGORIES;
export const CREATE_PRODUCT_CATEGORY_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.CREATE_PRODUCT_CATEGORY;
export const UPDATE_PRODUCT_CATEGORY_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.UPDATE_PRODUCT_CATEGORY;
export const DELETE_PRODUCT_CATEGORY_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.DELETE_PRODUCT_CATEGORY;
export const CREATE_HUB_PRODUCT_ENDPOINT_INSIDE = NEXT_API_ROUTES.CREATE_HUB_PRODUCT;
export const UPDATE_HUB_PRODUCT_ENDPOINT_INSIDE = NEXT_API_ROUTES.UPDATE_HUB_PRODUCT;
export const DELETE_HUB_PRODUCT_ENDPOINT_INSIDE = NEXT_API_ROUTES.DELETE_HUB_PRODUCT;
export const CREATE_HUB_CATEGORY_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.CREATE_HUB_CATEGORY;
export const UPDATE_HUB_CATEGORY_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.UPDATE_HUB_CATEGORY;
export const DELETE_HUB_CATEGORY_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.DELETE_HUB_CATEGORY;

export const PRODUCT_REQUESTS_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.GET_PRODUCT_REQUESTS;
export const CREATE_PRODUCT_REQUEST_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.CREATE_PRODUCT_REQUEST;
export const UPDATE_PRODUCT_REQUEST_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.UPDATE_PRODUCT_REQUEST;
export const DELETE_PRODUCT_REQUEST_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.DELETE_PRODUCT_REQUEST;
export const APPROVE_PRODUCT_REQUEST_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.APPROVE_PRODUCT_REQUEST;
export const REJECT_PRODUCT_REQUEST_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.REJECT_PRODUCT_REQUEST;

// request-products-related
export const APPROVE_REQUEST_PRODUCT_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.APPROVE_REQUEST_PRODUCT;
export const REJECT_REQUEST_PRODUCT_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.REJECT_REQUEST_PRODUCT;

// assignment-related
export const CREATE_ASSIGNMENT_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.CREATE_ASSIGNMENT;
export const DELETE_ASSIGNMENT_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.DELETE_ASSIGNMENT;

// email credentials-related (POST/PATCH/DELETE only - GET uses outsideEndpoints)
export const CREATE_EMAIL_CREDENTIAL_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.CREATE_EMAIL_CREDENTIAL;
export const UPDATE_EMAIL_CREDENTIAL_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.UPDATE_EMAIL_CREDENTIAL;
export const DELETE_EMAIL_CREDENTIAL_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.DELETE_EMAIL_CREDENTIAL;
export const TEST_EMAIL_CREDENTIAL_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.TEST_EMAIL_CREDENTIAL;
export const ACTIVATE_EMAIL_CREDENTIAL_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.ACTIVATE_EMAIL_CREDENTIAL;

// ai-model-related (PUT only - GET uses outsideEndpoints)
export const UPDATE_AI_MODEL_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.UPDATE_AI_MODEL;

// domain status check (used by DNS Setup panel)
export const DOMAIN_STATUS_ENDPOINT_INSIDE = NEXT_API_ROUTES.DOMAIN_STATUS;

/**
 * ==============================
 * ==============================
 * ============================== NEXT.JS INTERNAL API ENDPOINTS END ==============================
 * ==============================
 * ==============================
 */
